import { Vector3 } from "three";

// Standard lat/lng → unit-sphere mapping that matches the default UVs
// of Three.js SphereGeometry for an equirectangular texture whose seam
// lies at 180° longitude (the convention used by NASA Blue Marble and
// most world-map sources).
export function latLngToVec3(
  latDeg: number,
  lngDeg: number,
  radius = 1,
  target = new Vector3(),
): Vector3 {
  const phi = ((90 - latDeg) * Math.PI) / 180;
  const theta = ((lngDeg + 180) * Math.PI) / 180;
  target.set(
    -radius * Math.sin(phi) * Math.cos(theta),
     radius * Math.cos(phi),
     radius * Math.sin(phi) * Math.sin(theta),
  );
  return target;
}

// Longitude approximation of the user's current meridian from the
// browser's UTC offset. Rough but good enough to frame the initial view.
export function userMeridianLongitude(date = new Date()): number {
  // getTimezoneOffset returns minutes WEST of UTC (positive for west).
  const offsetHours = -date.getTimezoneOffset() / 60;
  return offsetHours * 15;
}

export function formatCoord(lat: number, lng: number): string {
  const ns = lat >= 0 ? "N" : "S";
  const ew = lng >= 0 ? "E" : "W";
  return `${Math.abs(lat).toFixed(2)}°${ns}  ${Math.abs(lng).toFixed(2)}°${ew}`;
}
